import _ from 'lodash';
import Fuse from 'fuse.js';
import * as swsMiniResult from '../data/spotlightsearchKeywords.json';

const MAXLENGTH = 10;

function minihelpRecommend(q, locale) {
  const options = {
    shouldSort: true,
    minMatchCharLength: 2,
    keys: ['displayName'],
  };
  const lang = locale.substring(0, 2);
  let keywords = swsMiniResult.en;

  switch (lang) {
    case 'es':
      keywords = swsMiniResult.es;
      break;
    case 'fr':
      keywords = swsMiniResult.fr;
      break;
    case 'zh':
      keywords = swsMiniResult.zh;
      break;
    default:
      keywords = swsMiniResult.en;
      break;

  }
  const fuse = new Fuse(keywords, options);
  const result = fuse.search(q);
  if (Array.isArray(result) && result.length > 0) {
    const expectResult = result.slice(0, MAXLENGTH);
    const groupResult = _.groupBy(expectResult, 'segment');
    return groupResult;
  }
  return {};
}

module.exports = {
  minihelpRecommend,
};
